import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import NormalGameManager from "../../../manager/NormalGameManager";
import { oreV2ObjInterface } from "./oreV2Const";
import oreV2ObjItem from "./oreV2ObjItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class oreV2NormalClean extends cc.Component {

    @property({type:cc.Node,displayName:"物品摆放的节点"})
    objContent:cc.Node = null;

    @property({type:cc.Label,displayName:"价格文本"})
    lbPrice:cc.Label = null;
    
    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lbExplain:cc.Label = null;

    objNode:cc.Node = null;

    objData:oreV2ObjInterface = null;

    objPrice:number = 0;

    objScript:oreV2ObjItem = null;

    bindNode(node:cc.Node){
        this.objNode = node;
        this.objScript = node.getComponent(oreV2ObjItem);
        this.objData = this.objScript.objData;
        this.objPrice = data_control.getRandNumberOfArrayTwo([this.objData.sellPrice * .95,this.objData.sellPrice*1.05]);
        this.updateNode();
    }

    updateNode(){
        this.objNode.setParent(this.objContent);
        this.objNode.setPosition(cc.v2());
        this.lbPrice.string = data_control.getNumberFormat(this.objPrice);
        this.lbName.string = this.objData.name;
        this.lbExplain.string = this.objData.explain;

        let maxWidth = this.objContent.width;
        let maxHeight = this.objContent.height;

        let spWidth = this.objScript.spNode.width;
        let spHeight = this.objScript.spNode.height;

        let sWidth = Math.max(maxWidth,spWidth);
        let sHeight = Math.max(spHeight,maxHeight);

        if(sWidth == spWidth || spHeight == sHeight){
            // 缩小
            let wRadio = maxWidth / spWidth;
            let hRadio = maxHeight / spHeight;

            let maxRadio = Math.min(wRadio,hRadio);

            this.objScript.spNode.width *= maxRadio;
            this.objScript.spNode.height *= maxRadio;

        }else{
            // 放大
            let wRadio = maxWidth / spWidth;
            let hRadio = maxHeight / spHeight;

            let maxRadio = Math.max(wRadio,hRadio);
            maxRadio = Math.min(maxRadio,2);
            this.objScript.spNode.width *= maxRadio;
            this.objScript.spNode.height *= maxRadio;
        }
    }

    onBtnPushBack(){
        let bindBackID = this.objData.bindBackpackId;
        NormalGameManager._instance.onPushGoods(bindBackID,1);
        O1HD.getModules().uiControlModule.showMessageBox(`已将${this.objData.name}放入背包`);
        this.closeThis();
    }

    onBtnSell(){
        O1HD.getServices().userSrv.setCoins(this.objPrice,true);
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnSanBei(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            O1HD.getServices().userSrv.setCoins(this.objPrice * 3,true);
            this.closeThis();
        },()=>{},null,"矿区观看视频三倍领取");
    }

}
